var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({staticClass:"nav-link",class:_vm.classes},'router-link',_vm.$attrs,false),[_c('div',{staticClass:"nav-link__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }